export default __webpack_public_path__ + "static/media/fin_sec_2025.5e3be3ed.jpg";